<script>
	import { getContext, createEventDispatcher, onMount, onDestroy } from 'svelte'
	import { url } from '../library/scripts/Setup.svelte'
	import { storeData, storeImageModal } from '../library/scripts/Store.svelte'
	import { resize_image } from '../builder/builderUtils'
	import { get_image_size } from '../builder/builderUtils'
	import { styles } from '../library/scripts/styles'
	import Shader from '../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../builder/Alert.svelte'

	export let blockID
	export let selectedImage
	export let origImage
	export let imagePath

	let dispatch = createEventDispatcher()

	let configFile
	const stoData = storeData.subscribe((value) => {
		configFile = value
	})

	const globals = getContext('globals')
	const fsS = globals.fsS
	const fsX = globals.fsXS
	const hoverBg = globals.buttonBgHover
	const navHeight = globals.navHeight
	const colorMain = globals.colorMain
	const colorError = globals.colorError
	let image = document.getElementById(blockID + '_image_' + selectedImage)
	let naturalWidth = image.naturalWidth
	let naturalHeight = image.naturalHeight

	const imageSize = async () => {
		const tS = await get_image_size(imagePath)
		naturalWidth = tS[0]
		naturalHeight = tS[1]
	}

	//for the crop function
	let imageWidth
	let imageHeight
	let newImgWidth
	let newImgHeight
	let imageContainer
	let dragTopLeft = false
	let dragTopRight = false
	let dragBottomLeft = false
	let dragBottomRight = false
	let resizeWidth = naturalWidth
	let realMarginTop = 0
	let realMarginLeft = 0
	let cropCmd

	//resize shader
	let showCropTool = false

	//buttons
	let showSaveButton = false
	let showResizeTool = false
	let show_crop_dimensions = false

	//used to compensate cropper width at start (to prevent oversize of cropper shade)
	let adjustWidth = 0
	let adjustHeight = 0

	//alert
	let showAlert = false
	let message1 = ''
	let message2 = ''

	const close_modal = () => {
		
		storeImageModal.set(false)
		dispatch('onclose')
	}

	$: if (showCropTool || showResizeTool) showSaveButton = true

	const close_alert = () => {
		showAlert = false
	}

	const ok_alert = () => {
		if (cropCmd === 'resize') {
			newImgWidth = resizeWidth
			newImgHeight = (naturalHeight * newImgWidth) / naturalWidth
		}

		if (cropCmd === 'crop') {
			if (isNaN(realMarginTop)) realMarginTop = 0
			if (isNaN(realMarginLeft)) realMarginLeft = 0
		}

		const data = {
			cropCmd: cropCmd,
			blockname: blockID,
			image: selectedImage,
			x: newImgWidth,
			y: newImgHeight,
			marginTop: realMarginTop,
			marginLeft: realMarginLeft,
		}

		resize_image('resize_image', url, configFile.username, data)
	}
	const create_canvas = (blockID, selectedImage) => {
		let path = origImage

		//get the displayd image and image_container
		const width = document.getElementById('modal_container').clientWidth
		const height = (width * naturalHeight) / naturalWidth

		imageContainer = document.getElementById('image_container')
		let canvas = document.createElement('canvas')
		canvas.setAttribute('id', 'canvas')
		canvas.width = width
		canvas.height = height
		let ctx = canvas.getContext('2d')
		let image = new Image()
		image.src = path
		image.onload = () => {
			ctx.drawImage(image, 0, 0, width, height)
			imageContainer.appendChild(canvas)
		}
	}

	const resize_tool = () => {
		showResizeTool = true
		showCropTool = false
	}

	const save_tool = () => {
		if (showResizeTool) {
			message1 = `Resize ${selectedImage} ?`
			message2 = '!This action cannot be reversed!'
			cropCmd = 'resize'
		}

		if (showCropTool) {
			message1 = `Crop ${selectedImage} ?`
			message2 = '!This action cannot be reversed!'
			cropCmd = 'crop'
		}
		showAlert = true
	}

	const crop_tool = () => {
		const canvas = document.getElementById('canvas')
		imageWidth = canvas.clientWidth
		imageHeight = canvas.clientHeight
		showCropTool = showCropTool === true ? false : true
		if (showCropTool) {
			show_crop_dimensions = true
			showResizeTool = false
		}
		if (!showCropTool) {
			show_crop_dimensions = false
		}
		showResizeTool = false
		newImgWidth = naturalWidth
		newImgHeight = naturalHeight
	}

	const move_crosshair = (e) => {
		const canvas = document.getElementById('canvas')
		const bounds = canvas.getBoundingClientRect()
		const width = canvas.clientWidth
		const height = canvas.clientHeight
		let mouseX = e.clientX - bounds.left
		let mouseY = e.clientY - bounds.top

		//set mouseX to 0 if value is < 0.6
		if (mouseX < 0.6) mouseX = 0
		if (mouseY < 0.6) mouseY = 0
		if (mouseX > width - 1) mouseX = width - 1
		if (mouseY > height - 1) mouseY = height - 1

		//moving action for crosshairs
		if (dragTopLeft) {
			document.getElementById('topLeft').style.left = mouseX + 'px'
			document.getElementById('topLeft').style.top = mouseY + 'px'
			document.getElementById('topRight').style.top = mouseY + 'px'
			document.getElementById('bottomLeft').style.left = mouseX + 'px'

			//fit cropper
			cropper_action('topleft', mouseX, mouseY)
		}

		if (dragTopRight) {
			document.getElementById('topRight').style.left = mouseX + 'px'
			document.getElementById('topRight').style.top = mouseY + 'px'
			document.getElementById('topLeft').style.top = mouseY + 'px'
			document.getElementById('bottomRight').style.left = mouseX + 'px'
			cropper_action('topright', mouseX, mouseY)
		}

		if (dragBottomLeft) {
			document.getElementById('bottomLeft').style.left = mouseX + 'px'
			document.getElementById('bottomLeft').style.top = mouseY + 'px'
			document.getElementById('bottomRight').style.top = mouseY + 'px'
			document.getElementById('topLeft').style.left = mouseX + 'px'
			cropper_action('bottomleft', mouseX, mouseY)
		}

		if (dragBottomRight) {
			document.getElementById('bottomRight').style.left = mouseX + 'px'
			document.getElementById('bottomRight').style.top = mouseY + 'px'
			document.getElementById('bottomLeft').style.top = mouseY + 'px'
			document.getElementById('topRight').style.left = mouseX + 'px'
			cropper_action('bottomright', mouseX, mouseY)
		}
	}

	//cropper actions
	const cropper_action = (cmd, x, y) => {
		const mouseX = x
		const mouseY = y
		let resFactor

		const cropper = document.getElementById('cropper')
		const height = document.getElementById('image_container').clientHeight
		const width = document.getElementById('image_container').clientWidth
		let marginTop = cropper.style.marginTop.slice(0, cropper.style.marginTop.length - 2)
		let marginLeft = cropper.style.marginLeft.slice(0, cropper.style.marginLeft.length - 2)
		let marginRight = cropper.style.marginRight.slice(0, cropper.style.marginRight.length - 2)
		let marginBottom = cropper.style.marginBottom.slice(0, cropper.style.marginBottom.length - 2)

		//zero values
		if (marginLeft === '') marginLeft = 0
		if (marginTop === '') marginTop = 0
		if (marginRight === '') marginRight = 0
		if (marginBottom === '') marginBottom = 0

		resFactor = naturalWidth / width

		if (cmd === 'topleft') {
			cropper.style.marginTop = mouseY + 'px'
			cropper.style.marginLeft = mouseX + 'px'

			if (marginRight > 15) adjustWidth = 10
			cropper.style.width = width - marginLeft - marginRight + adjustWidth + 'px'

			if (marginBottom > 10) adjustHeight = 10
			cropper.style.height = height - marginTop - marginBottom + adjustHeight + 'px'
		}

		if (cmd === 'topright') {
			cropper.style.marginTop = mouseY + 'px'
			cropper.style.marginLeft = marginLeft + 'px'
			cropper.style.marginRight = width - mouseX + 'px'

			if (marginLeft > 10) adjustWidth = 10
			cropper.style.width = width - marginRight - marginLeft + adjustWidth + 'px'

			if (marginBottom > 10) adjustHeight = 10
			cropper.style.height = height - marginTop - marginBottom + adjustHeight + 'px'
		}

		if (cmd === 'bottomleft') {
			cropper.style.marginBottom = height - mouseY + 'px'
			cropper.style.marginLeft = mouseX + 'px'

			if (marginRight > 15) adjustWidth = 10
			cropper.style.width = width - marginLeft - marginRight + adjustWidth + 'px'

			if (marginBottom > 10) adjustHeight = 10
			cropper.style.height = height - marginTop - marginBottom + adjustHeight + 'px'
		}

		if (cmd === 'bottomright') {
			cropper.style.marginBottom = height - mouseY + 'px'
			cropper.style.marginRight = width - mouseX + 'px'

			if (marginRight > 10) adjustWidth = 10
			cropper.style.width = width - marginLeft - marginRight + adjustWidth + 'px'

			if (marginBottom > 10) adjustHeight = 10
			cropper.style.height = height - marginTop - marginBottom + adjustHeight + 'px'
		}

		newImgWidth = Math.round((width - marginLeft - marginRight) * resFactor)
		newImgHeight = Math.round((height - marginTop - marginBottom) * resFactor)
		realMarginLeft = marginLeft * resFactor
		realMarginTop = marginTop * resFactor
	}

	//deactivate corners
	const crop_stop = () => {
		dragTopLeft = false
		dragTopRight = false
		dragBottomLeft = false
		dragBottomRight = false
	}

	//activate corners
	const top_left = () => {
		dragTopLeft = true
	}

	const top_right = () => {
		dragTopRight = true
	}

	const bottom_left = () => {
		dragBottomLeft = true
	}

	const crop_bottom_right = () => {
		dragBottomRight = true
	}

	onMount(() => {
		create_canvas(blockID, selectedImage)
		imageSize()
	})

	onDestroy(() => {
		stoData
	})
</script>

<div class="container" id="modal_container" on:mousemove={move_crosshair} use:styles={{ navHeight }}>
	<div class="close_bar">
		<div class="close_icon" on:click={close_modal} on:keydown={close_modal} />
	</div>
	<div class="dimension" use:styles={{ fsS, colorMain }}>
		<div>original:</div>
		<div>{naturalWidth} x {naturalHeight} px</div>
		{#if showResizeTool}
			<div>resize width:</div>
			<input type="number" bind:value={resizeWidth} min="100" max={naturalWidth} />
		{/if}

		{#if showCropTool}
			<div>new dimension:</div>
			<div>{newImgWidth} x {newImgHeight} px</div>
		{/if}
	</div>
	<div class="button_container">
		<button on:click={resize_tool} use:styles={{ colorMain, fsX, hoverBg, colorError }}>resize width</button>

		<button on:click={crop_tool} use:styles={{ colorMain, fsX, hoverBg, colorError }}>crop tool</button>

		{#if showSaveButton}
			<button on:click={save_tool} use:styles={{ colorMain, fsX, hoverBg, colorError }}>save</button>
		{/if}
	</div>
	<div class="image_area" id="image_area">
		<div class="image_container" id="image_container" on:mouseup={() => crop_stop('stop')}>
			{#if showCropTool}
				<div id="topLeft" class="crop cropleftTop" on:mousedown={top_left} />
				<div id="topRight" class="crop croprightTop" on:mousedown={top_right} />
				<div id="bottomLeft" class="crop cropleftBottom" on:mousedown={bottom_left} />
				<div id="bottomRight" class="crop croprightBottom" on:mousedown={crop_bottom_right} />
				<div id="cropper" class="cropper" />
			{/if}
		</div>
	</div>
</div>

{#if showAlert}
	<Shader>
		<div slot="content"><Alert {message1} {message2} on:alertclose={close_alert} on:alertok={ok_alert} /></div>
	</Shader>
{/if}

<style>
	input {
		color: var(--colorMain);
		font-size: var(--fsS);
		width: 150px;
		height: 100%;
		padding: 0;
		margin: 0;
		outline: none;
		background-color: transparent;
		border: 1px solid green;
	}

	button {
		outline: none;
		padding: 5px;
		margin: 0;
		border: 1px solid green;
		border-radius: 5px;
		background-color: transparent;
		color: var(--colorMain);
		font-size: var(--fsX);
		height: 25px;
		margin-left: 10px;
		cursor: pointer;
	}

	button:hover {
		background-color: var(--hoverBg);
	}

	.container {
		position: absolute;
		top: 30px;
		left: 50%;
		width: clamp(280px, 35vw, 500px);
		height: auto;
		transform: translate(-50%, 0);
	}

	.close_bar {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		width: 100%;
		height: 20px;
	}

	.close_icon {
		background-color: white;
		height: clamp(10px, 1.5vw, 20px);
		width: clamp(10px, 1.5vw, 20px);
		cursor: pointer;
		mask-size: cover;
		mask: url('/images/close.svg') no-repeat;
		-webkit-mask-size: cover;
		-webkit-mask: url('/images/close.svg') no-repeat;
	}

	.close_icon:hover {
		background-color: red;
	}

	.dimension {
		display: grid;
		grid-template-columns: 50% 50%;
		grid-row-gap: 15px;
		align-items: center;
		color: var(--colorMain);
		font-size: var(--fsS);
	}

	.button_container {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		width: 100%;
		height: 30px;
		margin: 2% 0% 2% 0%;
	}

	.image_area {
		position: relative;
		top: 0px;
	}

	.image_container {
		position: relative;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
	}

	.cropper {
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		background-color: hsla(0, 0%, 0%, 0.4);
		border: 1px dashed red;
	}

	.crop {
		display: block;
		position: absolute;
		width: 10px;
		height: 10px;
		background-color: black;
		mask-size: cover;
		mask: url('/images/tools/crosshair.svg') no-repeat;
		-webkit-mask-size: cover;
		-webkit-mask: url('/images/tools/crosshair.svg') no-repeat;
		z-index: 100;
		cursor: move;
	}

	.cropleftTop {
		left: 0;
		top: 0;
	}

	.cropleftBottom {
		left: 0;
		bottom: 0;
	}

	.croprightTop {
		right: 0;
		top: 0;
	}

	.croprightBottom {
		right: 0;
		bottom: 0;
	}
</style>
